import { StatusCodes } from 'http-status-codes';
import { useEffect } from 'react';
import axiosInstance from '../../utils/axiosApi';
import { maintenance_reason } from '../../utils/constants';
import { useGetActiveMaintenancesQuery } from './maintenanceSlice';

const WithMaintenance = ({ children }) => {
  const { refetch } = useGetActiveMaintenancesQuery();

  useEffect(() => {
    const interceptorId = axiosInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (
          error.response?.status ===
            StatusCodes.SERVICE_UNAVAILABLE &&
          error.response?.data?.metadata?.reason ===
            maintenance_reason
        ) {
          refetch();
          return error.response;
        }
        return Promise.reject(error);
      },
    );
    refetch();

    return () => {
      axiosInstance.interceptors.response.eject(interceptorId);
    };
  }, [refetch]);

  return children;
};

export default WithMaintenance;
